import { useLocation, useParams } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';

import { PrevHeaderBarWithTitleTemplate } from '#templates';

import ReactQuillEditor from 'src/refactor_shared/ui/react-quill-editor';
import { useState } from 'react';
import useAnswerMutations from 'src/r_page/qna-community/useAnswerMutations';
import { useUserInfo } from '#providers/UserInfo';
import QuestionInfo from 'src/r_page/qna-community/Answer/question-info';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { axios } from '#api/axios';
import { number } from 'prop-types';

type QnaCommunityAnswerProps = {
  content: string;
};

const QnaCommunityAnswerWrite = () => {
  const params = useParams();
  const { state } = useLocation();
  const { userInfo } = useUserInfo();
  const queryClient = useQueryClient();

  const [questionModalOpen, setQuestionModalOpen] = useState(false);
  const methods = useForm<QnaCommunityAnswerProps>({
    defaultValues: state ? state : { content: '' }
  });

  const { data: question } = useQuery({
    queryKey: ['get-qna-community-question', params.id],
    queryFn: async () =>
      await axios.get(`/consumer/qna/questions/${params.id}`),
    enabled: !!params.id,
    select: ({ data }) => data
  });

  const { answerMutate } = useAnswerMutations({
    questionId: params.id,
    isEdit: state ? true : false
  });

  return (
    <>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(data => {
            answerMutate({
              ...data,
              writerId: userInfo?.id,
              questionId: params.id,
              sequence: state ? state.sequence : 0
            });
          })}
        >
          <PrevHeaderBarWithTitleTemplate
            title="답변 작성"
            rightContents={
              <button className="text-[#9170F2] text-[14px]">
                {state ? '수정' : '등록'}하기
              </button>
            }
          >
            <div className="p-20">
              <div className="rounded-12 bg-[#2E2B36]">
                <button
                  onClick={() => setQuestionModalOpen(true)}
                  type="button"
                  className="py-12 px-16 rounded-12 text-[#EAE8ED] flex items-center gap-4 w-full"
                >
                  <span className="text-[#9170F2]">Q.</span>
                  <span className="overflow-hidden text-ellipsis line-clamp-1">
                    {question.title}
                  </span>
                </button>
              </div>
              <ReactQuillEditor
                registerName="content"
                placeholder="답변을 통해 당신의 지식을 나타내 보세요."
              />
            </div>
          </PrevHeaderBarWithTitleTemplate>
        </form>
      </FormProvider>
      {questionModalOpen && (
        <QuestionInfo
          setQuestionModalOpen={setQuestionModalOpen}
          question={question}
        />
      )}
    </>
  );
};

export default QnaCommunityAnswerWrite;
